module.exports = __webpack_public_path__ + "img/kow-map-no-city.d80e22db.png";